<template>
  <section class="about-section">

    <div class="container">

      <div class="header">

        <h1>
          Qui sommes-nous ?
        </h1>

        <p>
          Découvrez l'histoire de <strong>HayMiutyun</strong> et notre vision
          pour créer une communauté arménienne unie et solidaire.
        </p>

      </div>


    <div class="cards">


  <div class="card">

    <div class="icon">
      <HeartHandshake />
    </div>

    <h2>
      Qu’est-ce que HayMiutyun ?
    </h2>

    <p>
      HayMiutyun est une plateforme qui rassemble la communauté arménienne
      autour d'une valeur essentielle :
      <strong>l'entraide</strong>.
    </p>

    <p>
      Notre objectif est de connecter les personnes qui ont besoin de soutien
      avec celles qui souhaitent aider, afin de créer un réseau solidaire
      basé sur le partage, la confiance et la solidarité.
    </p>

  </div>



  <div class="card highlight">

    <div class="icon">
      <UsersRound />
    </div>

    <h2>
      Notre origine
    </h2>

    <p>
      HayMiutyun a été créé par
      <strong>deux jeunes Arméniens</strong> qui souhaitent construire
      une véritable communauté d'entraide arménienne.
    </p>

    <p>
      Notre ambition est de rapprocher les membres de notre communauté,
      permettre l'échange d'opportunités et aider ceux qui en ont besoin.
    </p>

  </div>



  <div class="card">

    <div class="icon">
      <Rocket />
    </div>

    <h2>
      Nos projets
    </h2>

    <p>
      HayMiutyun n’en est <strong>qu’à ses débuts.</strong>
      De nombreux projets sont en préparation afin de faire grandir
      notre communauté et renforcer les liens entre ses membres.
    </p>

    <p>
      Notre ambition est de développer de nouveaux services,
      organiser des actions solidaires et créer un espace où chaque
      Arménien pourra participer, partager et contribuer à son échelle.
    </p>

  </div>


</div>
    </div>

  </section>
</template>

<script setup>
import {
  HeartHandshake,
  UsersRound,
  Rocket
} from "lucide-vue-next"
</script>

<style scoped>

*{
  box-sizing:border-box
}

.about-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc)
}

.container{
  max-width:1200px;
  width:100%;
  margin:auto
}


.header{
  text-align:center;
  margin-bottom:50px
}


.header h1{
  font-size:48px;
  font-weight:800;
  margin:0 0 15px;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}


.header p{
  max-width:750px;
  margin:auto;
  color:#666;
  font-size:18px;
  line-height:1.8
}


.cards{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px
}


.card{
  background:white;
  padding:32px;
  border-radius:25px;
  box-shadow:0 15px 40px rgba(0,0,0,.08);
  transition:.35s;
  border-top:4px solid transparent;
  text-align:center
}


.card:nth-child(1){
  border-color:#D90012
}


.card:nth-child(2){
  border-color:#0033A0
}


.card:nth-child(3){
  border-color:#F2A800
}


.card:hover{
  transform:translateY(-8px);
  box-shadow:0 25px 50px rgba(0,0,0,.12)
}


.icon{
  width:60px;
  height:60px;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:0 auto 20px;
  border-radius:20px;
  background:#fff1f2;
  color:#D90012;
  font-size:28px;
  font-weight:bold
}


.card:nth-child(2) .icon{
  background:#eaf0ff;
  color:#0033A0
}


.card:nth-child(3) .icon{
  background:#fff7df;
  color:#F2A800
}


.card h2{
  font-size:24px;
  margin:0 0 15px;
  color:#222
}


.card p{
  color:#666;
  line-height:1.8
}


.card strong{
  color:#222
}


@media(max-width:900px){

  .cards{
    grid-template-columns:1fr
  }

  .header h1{
    font-size:36px
  }

}


@media(max-width:480px){

  .about-section{
    padding:25px 15px
  }

  .header h1{
    font-size:32px
  }

  .card{
    padding:25px 20px
  }

}

</style>